import { AnonymousUser, PresenceUser, PresentUser } from 'types'
import { onlyNumbers } from 'utils'

export const consolidatedUserId = (user: PresenceUser): number => {
  if (!user) return 0
  return (user as PresentUser).id || onlyNumbers((user as AnonymousUser).uuid)
}
